<template>
  <div class="member-history-page">
    <div class="page-hero">
      <div class="hero-top">
        <button class="hero-back" @click="$router.go(-1)">
          <img src="../assets/back.png" alt="back" />
        </button>
        <div class="hero-title">会员中心</div>
        <div class="hero-space"></div>
      </div>
      <!-- <div class="hero-copy">
        <div class="hero-desc">在会员查询与浏览记录之间快速切换</div>
      </div> -->
    </div>

    <div class="page-content">
      <!-- <div class="tab-strip">
        <button class="tab-pill" :class="{ active: activeState === 'query' }" @click="memberClick">会员查询</button>
        <button class="tab-pill" :class="{ active: activeState === 'record' }" @click="reocrdClick">浏览记录</button>
      </div> -->

      <div class="content-card">
        <div class="content-head">
          <div class="content-title">{{ currentSection.title }}</div>
          <div class="content-desc">{{ currentSection.desc }}</div>
        </div>

        <MemberQuery v-if="!queryVisible && visible" />
        <MemberCheck v-if="queryVisible && visible" />
      </div>
    </div>
  </div>
</template>
<script>
import MemberQuery from '@/components/matchmakerCenter/memberQuery.vue';
import MemberCheck from '@/components/matchmakerCenter/memberCheck.vue';
import { Toast } from 'vant';
import { getBrowsingHistory, getMemberList } from '../api/user';

export default {
  components: { MemberQuery, MemberCheck },
  data() {
    return {
      // queryVisible: false,
      // activeState: 'query',
      queryVisible: true,
      activeState: 'record',
      visible: false
    };
  },
  computed: {
    currentSection() {
      if (this.activeState === 'record') {
        return {
          title: '浏览记录',
          desc: '回看已浏览会员，方便继续了解与跟进。'
        };
      }
      return {
        title: '会员查询',
        desc: '按条件筛选会员并查看详情。'
      };
    }
  },
  methods: {
    reocrdClick() {
      this.activeState = 'record';
      this.queryVisible = true;
      this.visible = false;
      this.$store.dispatch('SetQueryName', 'check');
      getBrowsingHistory(this.$store.getters.baseInfo.id).then(res => {
        if (res.code === 20000) {
          this.$store.dispatch('SetReocrdList', res.data);
          this.visible = true;
        } else {
          Toast.fail({ message: `${res.msg}` });
        }
      });
    },
    memberClick() {
      this.activeState = 'query';
      this.queryVisible = false;
      this.visible = false;
      this.$store.dispatch('SetQueryName', 'query');
      this.$store.dispatch('SET_QueryList', { page: 1 });
      const queryPage = this.$store.getters.queryPage;
      const educationData = ['大专', '本科', '硕士', '博士', '高中及以下'];
      const params = {
        sex: queryPage.sex ? (queryPage.sex === '男' ? 1 : 2) : '',
        education: queryPage.education ? educationData.indexOf(queryPage.education) + 1 : '',
        minimumBirthday: queryPage.minimumBirthday ? new Date(queryPage.minimumBirthday + '-01-01').toISOString() : '',
        maximumBirthday: queryPage.maximumBirthday ? new Date(queryPage.maximumBirthday + '-12-31').toISOString() : '',
        minimumHeight: queryPage.minimumHeight,
        maximumHeight: queryPage.maximumHeight,
        hometown: queryPage.hometown,
        serialNumber: queryPage.serialNumber,
        page: 1,
        pageSize: 10
      };
      getMemberList(params).then(res => {
        if (res.code === 20000) {
          this.$store.dispatch('SetInfoList', res.data.items);
          this.visible = true;
        } else {
          Toast.fail({ message: `${res.msg}` });
        }
      });
    }
  },
  created() {
      this.reocrdClick();
    // if (this.$store.getters.queryListName === 'query') {
    //   this.memberClick();
    // } else if (this.$store.getters.queryListName === 'check') {
    //   this.reocrdClick();
    // }
  }
};
</script>
<style scoped lang="less" src="../style/memberBrowsingHistory.less" />



// WEBPACK FOOTER //
// src/views/memberBrowsingHistory.vue